<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AuthLayout',
  data() {
    return {
      contentVisible: false
    }
  },
  mounted() {
    this.contentVisible = true
  },
  unmounted() {
    this.contentVisible = false
  }
})
</script>

<template>
  <v-app>
    <transition name="fade-slide">
      <v-main v-if="contentVisible">
        <slot/>
      </v-main>
    </transition>
  </v-app>
</template>
